exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-tag.tag[data-v-4d49c2ae] {\n  padding: 0 0.571428571428571rem;\n  height: 1.357142857142857rem;\n  line-height: 1;\n  background-color: #b0b0b0;\n  color: #fff;\n  font-size: 0.79rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/common/src/components/Main/common/LxmTag.vue","/./src/components/Main/common/LxmTag.vue"],"names":[],"mappings":";AAOE;EACE,gCAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;CCNH","file":"LxmTag.vue","sourcesContent":["\n\n\n\n\n@import '../../styles/variables.styl'\n.lxm-tag\n  &.tag\n    padding: 0 siz(8)\n    height: siz(19)\n    line-height: 1\n    background-color: cloudy\n    color: white\n    font-size: size-small\n",".lxm-tag.tag {\n  padding: 0 0.571428571428571rem;\n  height: 1.357142857142857rem;\n  line-height: 1;\n  background-color: #b0b0b0;\n  color: #fff;\n  font-size: 0.79rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-4d49c2ae&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/common/LxmTag.vue
// module id = 630
// module chunks = 0